import * as actionTypes from "../actions/actionTypes";
import { updateObject } from "../utility";
import { stoageGetter } from "../../helpers";

const logindata = stoageGetter("user");
let id = "";
if (logindata) {
  id = logindata.id;
}

const initialState = {
  formData: {
    errorMessage: "",
    ruleEnach: {},
  },
};

//bi fetched
const fetchENACHDetails = (state, action) => {
  //console.log("STATE" ,state);
  //console.log("action" ,action);
  return updateObject(state, {
    formData: action.formData,
  });
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    // lead
    case actionTypes.FETCH_ENACH:
      return fetchENACHDetails(state, action);

    default:
      return state;
  }
};

export default reducer;
